<template>
  <Container>
    <div class="fee-tool">
      <div class="fee-toolbar">
        <RadioGroup v-model="type" type="button" @on-change="calc">
          <Radio
            v-for="t in types"
            :key="t.key"
            :label="t.key"
          >{{ t.name }}</Radio>
        </RadioGroup>
        <Button icon="md-refresh" @click="reset">重置示例</Button>
      </div>

      <div class="fee-card">
        <div class="fee-card-title">输入参数</div>
        <div class="fee-form-row">
          <div class="fee-field">
            <label>计算造价（万元）</label>
            <InputNumber
              v-model="costWan"
              :min="0"
              :active-change="false"
              style="width:100%"
              @on-change="calc"
            />
          </div>
          <div class="fee-field">
            <label>让利率（如下浮30%填 -0.3 或 0.3）</label>
            <InputNumber
              v-model="discountRate"
              :step="0.05"
              :active-change="false"
              style="width:100%"
              @on-change="calc"
            />
          </div>
        </div>
        <div class="fee-hint">本收费标准为计价格〔2002〕1980号文件规定标准，按分档累进计算。</div>
      </div>

      <div class="fee-card" v-if="result">
        <div class="fee-card-title">{{ result.title }}</div>
        <Table :columns="columns" :data="tableData" border size="small" />
        <div class="fee-summary">
          <div class="fee-sum-item">
            <span class="label">小计</span>
            <span class="value">{{ fmt(result.subtotal) }} 万元</span>
          </div>
          <div class="fee-sum-item">
            <span class="label">让利（{{ pct(result.discountRate) }}）</span>
            <span class="value warn">{{ fmt(result.concession) }} 万元</span>
          </div>
          <div class="fee-sum-item highlight">
            <span class="label">招标代理收费合计</span>
            <span class="value">{{ fmt(result.totalWan) }} 万元</span>
          </div>
          <div class="fee-sum-item">
            <span class="label">金额（元）</span>
            <span class="value">{{ fmtYuan(result.totalYuan) }} 元</span>
          </div>
          <div class="fee-sum-item full">
            <span class="label">金额大写</span>
            <span class="value">{{ result.words }}</span>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from '@/components/app/container';
import {AGENCY_TYPES, calcAgencyFee} from './fee-calc';

export default {
  components: {Container},
  data() {
    return {
      type: 'engineering',
      costWan: 10000,
      discountRate: -0.3,
      result: null,
      columns: [
        {title: '序号', key: 'index', width: 70, align: 'center'},
        {title: '收费区间（万元）', key: 'label', minWidth: 140},
        {
          title: '起值',
          key: 'start',
          width: 100,
          align: 'right',
          render: (h, {row}) => h('span', this.fmt(row.start)),
        },
        {
          title: '终值',
          key: 'end',
          width: 100,
          align: 'right',
          render: (h, {row}) => h('span', row.end == null ? '以上' : this.fmt(row.end)),
        },
        {
          title: '费率',
          key: 'rate',
          width: 100,
          align: 'right',
          render: (h, {row}) => h('span', this.pct(row.rate)),
        },
        {
          title: '小计（万元）',
          key: 'fee',
          width: 130,
          align: 'right',
          render: (h, {row}) => h('span', this.fmt(row.fee)),
        },
      ],
    };
  },
  computed: {
    types() {
      return Object.values(AGENCY_TYPES);
    },
    tableData() {
      return (this.result && this.result.rows) || [];
    },
  },
  mounted() {
    this.calc();
  },
  methods: {
    calc() {
      this.result = calcAgencyFee(this.costWan, this.type, this.discountRate);
    },
    reset() {
      this.costWan = 10000;
      this.discountRate = -0.3;
      this.type = 'engineering';
      this.calc();
    },
    fmt(v) {
      const n = Number(v) || 0;
      return n.toLocaleString('zh-CN', {maximumFractionDigits: 6});
    },
    fmtYuan(v) {
      const n = Number(v) || 0;
      return n.toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    },
    pct(v) {
      const n = Number(v) || 0;
      return `${(n * 100).toFixed(2)}%`;
    },
  },
};
</script>

<style lang="less" scoped>
@import './fee-tool.less';
</style>
